export default __webpack_public_path__ + "f8ffccfa0e0f6bfe8b29bc537e038bd1.png";